import  gql  from 'graphql-tag'

export const SET_GROUP_PERMISSIONS = gql`mutation setGroupPermissions($input: GroupUpdateMutationInput!){
    setGroupPermissions(input: $input){
        errors{
            field
            messages
        }
    }
}`;